import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { AccountService } from 'app/core';
import { CurrencyMaskOptions, getCurrencyMask } from 'app/shared/Utils/common.utils';
import { EditableComponent } from '../editable.types';

@Component({
  templateUrl: './images-editable.component.html',
  styleUrls: ['./images-editable.component.scss'],
})
export class ImagesEditableComponent extends EditableComponent implements OnInit {
  @ViewChild('inputEditorControl') inputEditorControl: ElementRef;

  public value: string = '';
  public editing: boolean = false;

  private get accountCurrency(): string {
    return this._accountService.getCurrentAccount()?.display_currency;
  }

  get currencyMaskOptions(): CurrencyMaskOptions {
    return getCurrencyMask(this.accountCurrency, 0);
  }

  constructor(private _accountService: AccountService) {
    super();
  }

  ngOnInit() {
    //this.value = this.model[this.fieldDef.name];
  }

  edit(): void {
    if (this.isDisabled) {
      return;
    }

    this.editing = true;
    setTimeout(() => {
      this.inputEditorControl.nativeElement.focus();
    }, 100);
  }

  onBlur($event: Event) {
    this.editing = false;
    this.updateModel();
    this.update.emit({ [this.fieldDef.name]: this.value });
  }

  updateModel() {
    this.model[this.fieldDef.name] = this.value;
  }
}
